// ./router.js
import React, { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./assets/style/style.scss";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/width.scss";
import Login from "./screen/Login/Login";
import ForgotPassword from "./screen/Login/ForgotPassword";
import ResetPassword from "./screen/Login/ResetPassword";
import Layout from "./components/Layouts/Layout";
import AdminList from "./screen/Admin/AdminList";
import AddAdmin from "./screen/Admin/AddAdmin";
import Dashboard from "./screen/Admin/Dashboard";
import Roles from "./screen/Admin/Roles";
import AddRoles from "./screen/Admin/AddRoles";
import OwnerList from "./screen/userList/owner/OwnerList";
import OwnerAdded from "./screen/userList/owner/OwnerAdded";
import Services from "./screen/Masters/Services";
import ServicesEdit from "./screen/Masters/ServicesEdit";
import Amenities from "./screen/Masters/Amenities";
// import CustomerList from "./screen/userList/customer/CustomerList";
import PropertyTags from "./screen/Masters/PropertyTags";
import Banner from "./screen/Masters/Banners/Banner";
import HomeBanner from "./screen/Masters/Banners/HomeBanner";
import AddHomeBanner from "./screen/Masters/Banners/AddHomeBanner";
import CustomerList from "./screen/userList/customer/CustomerList";
import CustomerView from "./screen/userList/customer/CustomerView";
import MasterLocation from "./screen/Location/MasterLocation";
import ReferandEarn from "./screen/Masters/Banners/ReferandEarn";
import BookingDetails from "./screen/Masters/Banners/BookingDetails";
import WalletBanner from "./screen/Masters/Banners/WalletBanner";
import DayOuting from "./screen/Masters/Banners/DayOuting";
import Owner from "./screen/Masters/Banners/Owner";
import PropertyBanner from "./screen/Masters/Banners/PropertyBanner";
import AddPropertyBanner from "./screen/Masters/Banners/AddPropertyBanner";
import Vedio from "./screen/Masters/Banners/Vedio";
import TimeSlot from "./screen/Masters/Banners/TimeSlot";
import HotelCategories from "./screen/Masters/Banners/HotelCategories";
import RoomCategories from "./screen/Masters/Banners/RoomCategories";
import Tips from "./screen/Masters/Banners/Tips";
import Commission from "./screen/Masters/Banners/Commission";
import CheckIn from "./screen/Masters/Banners/CheckIn";
import MinimumAge from "./screen/Masters/Banners/MinimumAge";
import MMC from "./screen/Masters/Banners/MMC";
import TermsAndCondition from "./screen/Masters/TermsAndCondition";
import HousePolicy from "./screen/Masters/HousePolicy";
import PropertiesList from "./screen/Property/PropertiesList";
import PropertyReqEdit from "./screen/Property/PropertyReqEdit";
import Receptionist from "./screen/Receptionist/Receptionist";
import ReceptionistAction from "./screen/Receptionist/ReceptionistAction";
import DeleteAccount from "./screen/Admin/DeleteAccount";
import PropertyDocEdit from "./screen/Property/PropertyDocEdit";
import MMCList from "./screen/Property/MMCList";
import RejectedList from "./screen/Property/RejectedList";
import DocumentVerificationList from "./screen/Property/DocumentVerificationList";
import PropertyMMCEdit from "./screen/Property/PropertyMMCEdit";
import EditDocumentVerification from "./screen/Property/EditDocumentVerification";
import EditDocumentMMC from "./screen/Property/EditDocumentMMC";
import ReferEarn from "./screen/Refer&Earn/ReferEarn";
import ReferEarnview from "./screen/Refer&Earn/ReferEarnview";
import WishList from "./screen/WishList/WishList";
import WishListView from "./screen/WishList/WishListView";
import NotifyMe from "./screen/NotifyMe/NotifyMe";
import NotifyMeView from "./screen/NotifyMe/NotifyMeView";
import OverallPropertiesList from "./screen/OverallProperties/OverallPropertiesList";
import PropertyDetails from "./screen/OverallProperties/PropertyDetails";
import WalletTransaction from "./screen/Wallettranscation/WalletTransaction";
import WalletTransactionadd from "./screen/Wallettranscation/WalletTransactionadd";
import WalletOwner from "./screen/Wallettranscation/WalletOwner";
import WalletOwnerAdd from "./screen/Wallettranscation/WalletOwnerAdd";
import RoomBookingView from "./screen/OverallProperties/RoomBookingView";
import Review from "./screen/Review/Review";
import ReviewView from "./screen/Review/ReviewView";
import Coupon from "./screen/Coupon/Coupon";
import CouponAdd from "./screen/Coupon/CouponAdd";
import CouponSingleAdd from "./screen/Coupon/CouponSingleAdd";
import HttpClient from "./Services/HttpClient";
import MMCTransactionList from "./screen/MMC/MMCTransactionList";
import MMCSuspendedList from "./screen/MMC/MMCSuspendedList";
import MMCSuspendedView from "./screen/MMC/MMCSuspendView";
import MMCCanReqView from "./screen/MMC/MMCCanReqView";
import MMCCanApprView from "./screen/MMC/MMCCanApprView";
import MMCCancellationList from "./screen/MMC/MMCCancellationList";
import MMCSuspendView from "./screen/MMC/MMCSuspendView";
import RoomListView from "./screen/OverallProperties/RoomListView";
import RoomTransactionView from "./screen/OverallProperties/RoomTransactionView";
import MMCTransactionView from "./screen/OverallProperties/MMCTransactionView";
import CancelReqView from "./screen/OverallProperties/CancelReqView";
import CancelApprView from "./screen/OverallProperties/CancelApprView";
import RoomBookingBlock from "./components/OverallProperties/RoomBooking/RoomBookingBlock";
import Properties_block from "./screen/Block/Properties_block";
import Room_block_view from "./screen/Block/Room_block_view";
import Rooms_block from "./screen/Block/Rooms_block";
import BookingList from "./screen/Bookings/BookingList";
import BookingView from "./screen/Bookings/BookingView";
import BookingListView from "./screen/Bookings/BookingListView";
import TransactionList from "./screen/Transaction/TransactionList";
import TransactionView from "./screen/Transaction/TransactionView";
import ReferPage from "./screen/ReferPage/ReferPage";
import AbsentList from "./screen/Notification/AbsentList";
import Deactivate from "./screen/userList/deactivate";
import Maintanence from "./screen/VowSettings/Maintanence";
import VowSettings from "./screen/VowSettings/VowSettings";
import VideoBannersList from "./screen/Masters/VideoBanners/VideoBannersList";
import VideoBannersAdd from "./screen/Masters/VideoBanners/VideoBannersAdd";
import DailyLogReport from "./screen/DailyLog/DailyLogReport";
import BookingCancelReason from "./screen/Masters/Banners/BookingCancelReason";
import ReferMessage from "./screen/Masters/ReferMessage";
import BookingHistoryBanner from "./screen/Masters/Banners/BookingHistoryBanner";
import AddBookingHistoryBanner from "./screen/Masters/Banners/AddBookingHistoryBanner";
import PropertyBlueFlag from "./screen/Flag/PropertyBlueFlag";
import PropertyRedFlag from "./screen/Flag/PropertyRedFlag";
import UserList from "./screen/Notification/UserList";
import UserNotificationAdd from "./screen/Notification/UserNotificationAdd";
import SmsGateway from "./screen/SmsGateway/SmsGateway";
import WhatsappDetails from "./screen/WhatsappDetails/WhatsappDetails";
import OfficeIp from "./screen/OfficeIp/OfficeIp";
import AuditLog from "./screen/AuditLog/AuditLog";
import TwoStepVerification from "./screen/Login/TwoStepVerification";
import MMCDeactiveList from "./screen/MMC/MMCDeactiveList";
import InvoiceUser from "./screen/InvoiceUser/InvoiceUser";
import PaymentGateWay from "./screen/PaymentGateWay/PaymentGateWay";
import UserFailedTransaction from "./screen/PaymentGateWay/UserFailedTransaction";
import TransactionsList from "./screen/PaymentGateWay/TransactionsList";
import UserFailedNotesTransaction from "./screen/PaymentGateWay/UserFailedNotesTransaction";
import FailedNotificationDetails from "./screen/PaymentGateWay/FailedNotificationDetails";
import FailedTransactionView from "./screen/PaymentGateWay/FailedTransactionView";
import ArrivalSOS from "./screen/Masters/Banners/ArrivalSOS";
import RoomSOS from "./screen/Masters/Banners/RoomSOS";
import SOSAlert from "./screen/VowSettings/SOSAlert";
import SOSAlerts from "./screen/SOSAlerts/SOSAlerts";
import RazyPay from "./screen/VowSettings/RazyPay";
import TutorialVideos from "./screen/TutorialVideos/TutorialVideos";
import TutorialLanguages from "./screen/TutorialVideos/TutorialLanguages";
import TutorialCategories from "./screen/TutorialVideos/TutorialCategories";
import VideosList from "./screen/TutorialVideos/VideosList";
import AddVideo from "./screen/TutorialVideos/AddVideo";
import FireBaseShow from "./screen/VowSettings/FireBaseShow";
import ViewVideo from "./screen/TutorialVideos/ViewVideo";
import AIWare from "./screen/AIWare/AIWare";
import AISupport from "./screen/AISupport/AISupport";
import AiArea from "./screen/AISupport/AiArea";
import AiNotification from "./screen/AISupport/AiNotification";

const AppRoutes = () => {
  const token = localStorage.getItem("token");
  if (token) {
    HttpClient.defaults.headers.common["Authorization"] =
      `Bearer ${token}` || "";
  }

  return (
    <Routes>
      <Route
        path="/"
        element={token ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/reset-password/:params" element={<ResetPassword />} />
      <Route path="/refer-page" element={<ReferPage />} />
      <Route path="/two-stepverification" element={<TwoStepVerification />} />

      <Route element={<Layout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminList />} />
        <Route path="/add-admin" element={<AddAdmin />} />
        <Route path="/roles" element={<Roles />} />
        <Route path="/add-roles" element={<AddRoles />} />
        <Route path="/user-owner" element={<OwnerList />} />
        <Route path="/add-owner" element={<OwnerAdded />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services-edit" element={<ServicesEdit />} />
        <Route path="/amenities" element={<Amenities />} />
        <Route path="/customer-list" element={<CustomerList />} />
        <Route path="/customer-view" element={<CustomerView />} />
        <Route path="/property-tags" element={<PropertyTags />} />
        <Route path="/banners" element={<Banner />} />
        <Route path="/home-banners" element={<HomeBanner />} />
        <Route path="/add-home-banners" element={<AddHomeBanner />} />
        <Route path="/property-banners" element={<PropertyBanner />} />
        <Route path="/add-property-banners" element={<AddPropertyBanner />} />
        <Route
          path="/add-booking-history-banners"
          element={<AddBookingHistoryBanner />}
        />
        <Route path="/refer-and-earn" element={<ReferandEarn />} />
        <Route path="/booking-details" element={<BookingDetails />} />
        <Route path="/wallet-banner" element={<WalletBanner />} />
        <Route path="/day-outing" element={<DayOuting />} />
        <Route path="/owner-banner" element={<Owner />} />
        <Route path="/booking-banner" element={<BookingHistoryBanner />} />
        {/* <Route path="/vedio" element={<Vedio />} /> */}
        <Route path="/vedio" element={<VideoBannersList />} />
        <Route path="/vedio-add" element={<VideoBannersAdd />} />
        <Route path="/time-slot" element={<TimeSlot />} />
        <Route path="/hotel-categories" element={<HotelCategories />} />
        <Route path="/room-categories" element={<RoomCategories />} />
        <Route path="/tips" element={<Tips />} />
        <Route path="/commission" element={<Commission />} />
        <Route path="/check-in" element={<CheckIn />} />
        <Route path="/arrival-sos" element={<ArrivalSOS />} />
        <Route path="/room-sos" element={<RoomSOS />} />
        <Route path="/sos-alert" element={<SOSAlert />} />
        <Route path="/minimum-age" element={<MinimumAge />} />
        <Route path="/mmc" element={<MMC />} />
        <Route path="/house-policy" element={<HousePolicy />} />
        <Route path="/terms-condition" element={<TermsAndCondition />} />
        <Route path="/refer-message" element={<ReferMessage />} />
        <Route path="/properties" element={<PropertiesList />} />
        <Route path="/propertie-req-edit" element={<PropertyReqEdit />} />
        <Route path="/propertie-doc-edit" element={<PropertyDocEdit />} />
        <Route path="/propertie-mmc-edit" element={<PropertyMMCEdit />} />
        <Route path="/mmc-transaction-list" element={<MMCTransactionList />} />
        <Route path="/mmc-suspended-list" element={<MMCSuspendedList />} />
        <Route path="/mmc-deactive-list" element={<MMCDeactiveList />} />
        <Route
          path="/mmc-cancellation-list"
          element={<MMCCancellationList />}
        />
        <Route path="/mmc-suspend-view" element={<MMCSuspendView />} />
        <Route path="/mmc-cancel-req-view" element={<MMCCanReqView />} />
        <Route path="/mmc-cancel-appr-view" element={<MMCCanApprView />} />
        <Route
          path="/properties-doc-verfication"
          element={<DocumentVerificationList />}
        />
        <Route
          path="/doc-verfication-edit"
          element={<EditDocumentVerification />}
        />
        <Route path="/doc-verfication-mmc" element={<EditDocumentMMC />} />
        <Route path="/overall-properties" element={<OverallPropertiesList />} />
        <Route path="/property-details" element={<PropertyDetails />} />
        <Route path="/room-booking-view" element={<RoomBookingView />} />
        <Route path="/room-list-view" element={<RoomListView />} />
        <Route
          path="/room-transaction-view"
          element={<RoomTransactionView />}
        />
        <Route path="/room-booking-block" element={<RoomBookingBlock />} />
        <Route path="/rooms-block" element={<Rooms_block />} />
        <Route path="/properties-block" element={<Properties_block />} />
        <Route path="/rooms-block-view" element={<Room_block_view />} />
        <Route path="/mmc-transaction-view" element={<MMCTransactionView />} />
        <Route path="/mmc-suspended-view" element={<MMCSuspendedView />} />
        <Route path="/cancel-req-view" element={<CancelReqView />} />
        <Route path="/cancel-appr-view" element={<CancelApprView />} />
        <Route path="/properties-mmc" element={<MMCList />} />
        <Route path="/properties-rejected" element={<RejectedList />} />
        <Route path="/location" element={<MasterLocation />} />
        <Route path="/receptionist-action" element={<ReceptionistAction />} />
        <Route path="/receptionist" element={<Receptionist />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/cancel-reason" element={<BookingCancelReason />} />
        <Route path="/referearn" element={<ReferEarn />} />
        <Route path="/referearnview" element={<ReferEarnview />} />
        <Route path="/wishlist" element={<WishList />} />
        <Route path="/wishlistview" element={<WishListView />} />
        <Route path="/notifyme" element={<NotifyMe />} />
        <Route path="/notifymeview" element={<NotifyMeView />} />
        <Route path="/wishlist" element={<WishList />} />
        <Route path="/wishlistview" element={<WishListView />} />
        <Route path="/notifyme" element={<NotifyMe />} />
        <Route path="/notifymeview" element={<NotifyMeView />} />
        <Route path="/wallettransaction" element={<WalletTransaction />} />
        <Route
          path="/wallettransactionadd"
          element={<WalletTransactionadd />}
        />
        <Route path="/booking-list" element={<BookingList />} />
        <Route path="/booking-view" element={<BookingView />} />
        <Route path="/booking-list-view" element={<BookingListView />} />
        <Route path="/transaction-list" element={<TransactionList />} />
        <Route path="/transaction-view" element={<TransactionView />} />
        <Route path="/wallet-owner" element={<WalletOwner />} />
        <Route path="/wallet-owner-add" element={<WalletOwnerAdd />} />
        <Route path="/review" element={<Review />} />
        <Route path="/reviewview" element={<ReviewView />} />
        <Route path="/coupon" element={<Coupon />} />
        <Route path="/couponadd" element={<CouponAdd />} />
        <Route path="/coupon-single-add" element={<CouponSingleAdd />} />

        {/*In App updates*/}
        <Route path="/vow-settings" element={<VowSettings />} />

        {/* Maintanence */}
        <Route path="/maintenance" element={<Maintanence />} />

        <Route path="/daily-log" element={<DailyLogReport />} />

        {/* notification  */}
        <Route path="/absentlist" element={<AbsentList />} />
        <Route path="/deactivate" element={<Deactivate />} />

        {/* Flag */}
        <Route path="/property-flag-blue" element={<PropertyBlueFlag />} />
        <Route path="/property-flag-red" element={<PropertyRedFlag />} />
        <Route path="/user-list" element={<UserList />} />
        <Route
          path="/user-notification-add"
          element={<UserNotificationAdd />}
        />
        <Route path="/sms-gateway" element={<SmsGateway />} />
        <Route path="/whatsapp-details" element={<WhatsappDetails />} />
        <Route path="/office-ip" element={<OfficeIp />} />
        <Route path="/audit-log" element={<AuditLog />} />
        <Route path="/invoice-user" element={<InvoiceUser />} />
        <Route path="/payment-gateway" element={<PaymentGateWay />} />
        <Route
          path="/userfailedtransaction"
          element={<UserFailedTransaction />}
        />
        <Route path="/failed_transaction" element={<TransactionsList />} />
        <Route
          path="/userFailedNotesTransaction"
          element={<UserFailedNotesTransaction />}
        />
        <Route
          path="/failedtransactionview"
          element={<FailedTransactionView />}
        />
        <Route
          path="/FailedNotificationDetails"
          element={<FailedNotificationDetails />}
        />
        <Route path="/sos-alerts" element={<SOSAlerts />} />
        <Route path="/razorpay-key" element={<RazyPay />} />

        {/* tutorial videos */}
        <Route path="/tutorial-videos" element={<TutorialVideos />} />
        <Route path="/tutorial-languages" element={<TutorialLanguages />} />
        <Route path="/tutorial-categories" element={<TutorialCategories />} />
        <Route path="/videos-list" element={<VideosList />} />
        <Route path="/add-video" element={<AddVideo />} />
        <Route path="/view-video" element={<ViewVideo />} />
        <Route path="/firebaseshow" element={<FireBaseShow />} />
        <Route path="/ai-ware" element={<AIWare />} />
        <Route path="/ai-report" element={<AISupport />} />
        <Route path="/ai-area" element={<AiArea />} />
        <Route path="/ai-notification" element={<AiNotification />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
